var _circle, _path, _path2, _circle2, _path3, _path4, _circle3, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgPoorIcon = function SvgPoorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 5657",
    width: 28.874,
    height: 28.874
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 362",
    cx: 14.437,
    cy: 14.437,
    fill: "#fdd402",
    r: 14.437
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3823",
    d: "M3.946 14.437A14.439 14.439 0 0116.41.137a14.437 14.437 0 100 28.6 14.44 14.44 0 01-12.464-14.3z",
    fill: "#fbbf13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3824",
    d: "M20.663 21.52a.5.5 0 01-.35-.143 7.789 7.789 0 00-5.481-2.241h-.466a7.789 7.789 0 00-5.48 2.242.5.5 0 01-.7-.711 8.787 8.787 0 016.179-2.529h.466a8.787 8.787 0 016.179 2.529.5.5 0 01-.35.855zM6.055 11.976h-.018a.5.5 0 01-.481-.516 4.494 4.494 0 011.905-3.456 4.181 4.181 0 012.215-.666.5.5 0 01.018 1 3.142 3.142 0 00-1.688.5 3.453 3.453 0 00-1.453 2.655.5.5 0 01-.498.482z",
    fill: "#74563a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 363",
    cx: 1.297,
    cy: 1.297,
    transform: "translate(8.589 10.644)",
    fill: "#74563a",
    r: 1.297
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3825",
    d: "M9.255 11.945a1.3 1.3 0 01.965-1.253 1.3 1.3 0 100 2.505 1.3 1.3 0 01-.965-1.252z",
    fill: "#674b34"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3826",
    d: "M23.153 11.976a.5.5 0 01-.5-.482A3.453 3.453 0 0021.2 8.839a3.142 3.142 0 00-1.688-.5.5.5 0 11.009-1h.009a4.181 4.181 0 012.215.666 4.494 4.494 0 011.905 3.456.5.5 0 01-.481.516z",
    fill: "#74563a"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 364",
    cx: 1.297,
    cy: 1.297,
    transform: "translate(18.029 10.644)",
    fill: "#74563a",
    r: 1.297
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3827",
    d: "M18.695 11.945a1.3 1.3 0 01.965-1.253 1.3 1.3 0 100 2.505 1.3 1.3 0 01-.965-1.252z",
    fill: "#674b34"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3828",
    d: "M19.8 16.4c-.035-.166-.138-.308-.308-.308s-.273.142-.308.308c-.411 1.951-2.053 2.978-2.053 4.928a2.362 2.362 0 104.723 0c-.001-1.951-1.644-2.978-2.054-4.928z",
    fill: "#4ebaea"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3829",
    d: "M18.46 21.328c0-1.573 1.067-2.545 1.7-3.885a4.732 4.732 0 01-.357-1.044c-.035-.166-.138-.308-.308-.308s-.273.142-.308.308c-.411 1.951-2.054 2.978-2.054 4.928a2.362 2.362 0 003.027 2.266 2.362 2.362 0 01-1.7-2.265z",
    fill: "#2e99d4"
  })));
};
export default SvgPoorIcon;